var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('v-card',{staticStyle:{"border":"1px solid var(--line-color) !important"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }